import { ArrowRight } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

const Careers: React.FC = () => {
  const jobListings = [
    {
      id: "sales-specialist",
      title: "Sales Specialist",
      location: "Chennai, India",
      intro:
        "We are looking for a Sales Specialist to join our team and help us grow our customer base. The ideal candidate will have a passion " +
        "for sales, a deep understanding of our products, and the ability " +
        "to build strong relationships with clients....",
    },
    {
      id: "founding-engineer",
      title: "Founding Engineer/Technical Lead",
      location: "Remote, US",
      intro:
        "We are looking for a Technical Lead to provide " +
        "sound technical leadership in all aspects of our business. You " +
        "will closely work with the CEO, stakeholders and customers to " +
        "understand the gaps in B2B businesses and focus on delivering " +
        "solutions to our merchants....",
      about:
        "Join a founding team at Expensehut where your decisions directly impact thousands of businesses. We move fast, think deeply, and believe in building products that solve real problems.",
      apply:
        "Email your resume and a portfolio of your best work to careers@expensehut.com with the subject line 'Product Manager Application'",
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Header */}
      <section className="pt-40 pb-24 px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-5xl lg:text-6xl font-bold mb-4">Join Our Team</h1>
          <p className="text-xl">
            Help us build the future of business operations & payments. We're
            looking for talented individuals passionate about solving real
            problems.
          </p>
        </div>
      </section>

      {/* Job Listings */}
      <section className="py-24 px-6 lg:px-8 border-t border-gray-800">
        <div className="max-w-4xl mx-auto space-y-8">
          {jobListings.map((job) => (
            <Link
              key={job.id}
              to={`/careers/${job.id}`}
              className="group block"
            >
              <div className="p-8 rounded-xl border border-gray-700 bg-gray-800 hover:bg-gray-750 hover:border-gray-600 transition">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-white mb-2">
                      {job.title}
                    </h3>
                    <p className="text-gray-400 mb-4">📍 {job.location}</p>
                  </div>
                  <ArrowRight className="text-gray-400 group-hover:text-blue-400 group-hover:translate-x-1 transition-all mt-1" />
                </div>

                <p className="text-gray-300 line-clamp-2 mb-4">
                  {job.intro.substring(0, 150)}...
                </p>

                <div className="flex items-center gap-2 text-blue-400 font-semibold">
                  View full details
                  <ArrowRight size={18} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Careers;
